import {
  WW_ORANGE,
  WW_ORANGE_LIGHT,
  WW_BLUE,
  WW_BLUE_MID,
  WW_BLUE_LIGHT,
  WHITE,
  WARN_SOFT,
  WARN_STRONG,
  PANEL_TEXT_MUTED,
  PANEL_TEXT_FAINT,
  PANEL_CARD_BG,
  PANEL_CARD_BORDER,
} from "./tokens"

const theme =
{
    palette: {
      primary: {
        dark: WW_BLUE,
        main: WW_BLUE_MID,
        light: WW_BLUE_LIGHT,
      },
      secondary: {
        main: WW_ORANGE,
        light: WW_ORANGE_LIGHT,
        contrastText: WHITE,
      },
      text: {
        primary: WW_BLUE,
        light: WHITE
      },
      warning: {
        main: WARN_STRONG,
        light: WARN_SOFT,
        contrastTextMain: WHITE,
        contrastTextLight: WW_BLUE
      }
    },
    // App-specific tokens that don't map onto MUI's palette; reachable via
    // useTheme()/sx callbacks as theme.custom.*
    custom: {
      panel: {
        text: WW_BLUE,
        textMuted: PANEL_TEXT_MUTED,
        textFaint: PANEL_TEXT_FAINT,
        cardBg: PANEL_CARD_BG,
        cardBorder: PANEL_CARD_BORDER,
      },
    },
    components: {
      // Focused outlined inputs use WW_BLUE instead of the default light-blue
      // primary.main — app-wide, for every TextField/Select/Autocomplete/picker.
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            "&.Mui-focused:not(.Mui-error) .MuiOutlinedInput-notchedOutline": {
              borderColor: WW_BLUE,
            },
          },
        },
      },
      // x-date-pickers fields use their own outlined-input slot.
      MuiPickersOutlinedInput: {
        styleOverrides: {
          root: {
            "&.Mui-focused:not(.Mui-error) .MuiPickersOutlinedInput-notchedOutline":
              {
                borderColor: WW_BLUE,
              },
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: { "&.Mui-focused": { color: WW_BLUE } },
        },
      },
    },
    typography: {
        fontSizeSmall: 12
    },
    mixins: {
        drawer: {
            width: 300
        },
        dashboardCardMedia: {
            marginTop: 2,
            marginLeft: 0,
            marginRight: 0,
            marginBottom: 0,
            height: 160,
            width: "auto"
        },
    }
}

export default theme
